/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const updateEnvironmentBodyNameMax = 255;

export const UpdateEnvironmentBody = zod
	.object({
		name: zod.string().min(1).max(updateEnvironmentBodyNameMax).describe('Environment name'),
		type: zod.enum(['production', 'sandbox'])
	})
	.describe('Environment creation\/update request');

export type UpdateEnvironmentBody = zod.input<typeof UpdateEnvironmentBody>;
export type UpdateEnvironmentBodyOutput = zod.output<typeof UpdateEnvironmentBody>;
